<script lang="ts" module>
  /** Stroke icons on a 24 grid, drawn to sit with the rounded look of the brand. */
  const PATHS = {
    heart:
      'M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2Z',
    cheer: 'M4 20l4.5-11 6.5 6.5L4 20Zm9-13.5V4m4.5 5.5L20 8m-1.5 5.5H21M14 4.5l-.5 1',
    laugh:
      'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-4.2-9.2c.5 3.2 2.3 4.7 4.2 4.7s3.7-1.5 4.2-4.7H7.8ZM8.6 9.2h.01M15.4 9.2h.01',
    fire: 'M12 21c-3.9 0-6.5-2.7-6.5-6.3 0-2.6 1.6-4.4 3-6 .8-.9 1.3-2 1.4-3.2 2.4 1 3.7 2.8 3.9 5 .8-.6 1.3-1.5 1.4-2.5 1.6 1.6 2.3 3.3 2.3 4.9 0 3.6-2.6 6.1-5.5 6.1Z',
    sad: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-4-3.8c.7-1.5 2-2.2 4-2.2s3.3.7 4 2.2M8.6 9.6h.01M15.4 9.6h.01',
    hand: 'M8 12V6.5a1.5 1.5 0 0 1 3 0V11m0-5.5V4.5a1.5 1.5 0 0 1 3 0V11m0-4.5a1.5 1.5 0 0 1 3 0V12m0-3.5a1.5 1.5 0 0 1 3 0v4.7c0 4-2.5 7.8-6.5 7.8h-1c-2.4 0-3.9-1-5.3-3L4.4 14.6a1.5 1.5 0 0 1 2.3-1.9L8 14',
    smile:
      'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-4-6c.9 1.3 2.2 2 4 2s3.1-.7 4-2M8.6 9.6h.01M15.4 9.6h.01',
    volume: 'M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4Zm11 .5a3.5 3.5 0 0 1 0 4m2.5-6.5a7 7 0 0 1 0 9',
    muted: 'M4 9.5v5h3.5L12 18.5v-13L7.5 9.5H4Zm11 1 5 5m0-5-5 5',
    pip: 'M4 6h16v12H4V6Zm7 5h7v5h-7v-5Z',
    pen: 'M4 20l1-4.5L16.5 4a2.1 2.1 0 0 1 3 3L8 18.5 4 20Zm9-13 3 3',
    theater: 'M3 7h18v10H3V7Zm4 0v10m10-10v10',
    fullscreen: 'M4 9V4h5M20 9V4h-5M4 15v5h5m11-5v5h-5',
    exit: 'M9 4v5H4m16 0h-5V4M9 20v-5H4m16 0h-5v5',
    check: 'M20 6 9.5 17 4 11.5',
    warn: 'M12 4 2.5 20h19L12 4Zm0 6v4.5m0 3h.01',
    chevron: 'M6 9l6 6 6-6',
    invite:
      'M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 20c.6-3.4 3-5 6.5-5s5.9 1.6 6.5 5M18 8v6m3-3h-6',
    eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    send: 'M12 19V5m0 0-6 6m6-6 6 6',
    sync: 'M20 11a8 8 0 0 0-14-4L4 9m0-5v5h5M4 13a8 8 0 0 0 14 4l2-2m0 5v-5h-5',
    stats: 'M5 20V11m7 9V4m7 16v-6',
    chat: 'M4 5h16v11H9.5L4 20.5V5Z',
    sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-12.5V5m0 14v1.5M4.9 4.9l1.1 1.1m12 12 1.1 1.1M3.5 12H5m14 0h1.5M4.9 19.1 6 18m12-12 1.1-1.1',
    moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z',
  } as const

  export type IconName = keyof typeof PATHS
</script>

<script lang="ts">
  let { name, size = 20 }: { name: IconName; size?: number } = $props()
</script>

<svg
  class="icon"
  viewBox="0 0 24 24"
  width={size}
  height={size}
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  <path d={PATHS[name]} />
</svg>
